import { createStyleSheet } from 'Components/foundation/stylesheets';

export const stylesheet = createStyleSheet({
  filter: {
    marginRight: '0px',
    height: '32px',
    flexGrow: 1,
  },
});

export default stylesheet;
